<ng-template #template>
  <label [class]="model.getItemClass(item.itemValue, item.highlight)" (mouseover)="model.onItemMouseIn(item)" (mouseout)="model.onItemMouseOut(item)" (mousedown)="model.onMouseDown()">
    <input type="radio"
      class="sv-visuallyhidden"
      [attr.name]="model.questionName" [attr.id]="model.getInputId(index)" [value]="item.value" [attr.aria-required]="model.ariaRequired" [attr.aria-label]="model.ariaLabel" [attr.aria-invalid]="model.ariaInvalid" [attr.aria-errormessage]="model.ariaErrormessage"
      [disabled]="model.isDisabledAttr" [readonly]="model.isReadOnlyAttr" [checked]="model.value === item.value" (click)="onClick($event)"
      />
      <svg [iconName]="model.itemStarIcon" [size]="'auto'" [title]="item.text" [class]="'sv-star'" sv-ng-svg-icon></svg>
      <svg [iconName]="model.itemStarIconAlt" [size]="'auto'" [title]="item.text" [class]="'sv-star-2'" sv-ng-svg-icon></svg>
  </label>
</ng-template>